import CoverageAvailable from "./coverageAvailable";
import ActionRequired from "./actionRequired";
import SpecialityPharmacy from "./specialityPharmacy";
import PendingTable from "./pending";
import { DashboardTabConfig, PatientFilterState, PatientFilterStateActions } from "./types";
import CopayBucketTable from "./copayBucket";


export const manufactureTabsConfig: DashboardTabConfig[] = [
  {
    key: "coverage_available",
    label: "COVERAGE AVAILABLE",
    description:
      "These are patients that have either medical coverage available and/or pharmacy coverage available.",
    Component: CoverageAvailable,
    dataSelector: (d:any) => d.coverage_available,
    pageKey: "treatable_page" as keyof PatientFilterState, // ✅ keyof PatientFilterState
    changeAction: PatientFilterStateActions.CHANGE_TREATABLE_PAGE,

  },
  {
    key: "action_required",
    label: "ACTION REQUIRED",
    description:
      "Cases requiring your attention before a treatment decision should be determined.",
    Component: ActionRequired,
    dataSelector: (d:any) => d.action_required,
    pageKey: "todo_page" as keyof PatientFilterState, // ✅ keyof PatientFilterState
    changeAction: PatientFilterStateActions.CHANGE_TODO_PAGE,

  },
  {
    key: "specialty_pharmacy",
    label: "TRANSFER TO PHARMACY",
    description:
      "Patients awaiting specialty pharmacy shipment. Update status when completed.",
    Component: SpecialityPharmacy,
    dataSelector: (d:any) => d.specialty_pharmacy,
    pageKey: "sp_treatment_page" as keyof PatientFilterState, // ✅ keyof PatientFilterState
    changeAction: PatientFilterStateActions.CHANGE_SP_TREATMENT_PAGE,

  },
  {
    key: "pending",
    label: "PENDINGS",
    description: "Cases with no or indeterminate coverage. Update patient status.",
    Component: PendingTable,
    dataSelector: (d:any) => d.pending,
    pageKey: "not_treated_page" as keyof PatientFilterState, // ✅ keyof PatientFilterState
    changeAction: PatientFilterStateActions.CHANGE_NOT_TREATED_PAGE,

  },
  {
    key: "copay_claims",
    label: "COPAY",
    description: "Cases with no or indeterminate coverage. Update patient status.",
    Component: CopayBucketTable,
    dataSelector: (d:any) => d.copay_claims,
    pageKey: "copay_claims_data_page" as keyof PatientFilterState, // ✅ keyof PatientFilterState
    changeAction: PatientFilterStateActions.CHANGE_COPAY_CLAIM,

  },
];
